import * as Sentry from '@sentry/vue'
import { mapState } from 'vuex'
import Util from '@/util'
import SelfPacedQuiz from '@/services/SelfPacedQuiz'
import SlideApi from '@/api/slide'

const PAGE_TITLE = 'Live Audience Engagement Platform - AhaSlides'

export default {
  computed: {
    ...mapState({
      slide: (state) => state.slide,
    }),
  },
  methods: {
    async selfPaceMoveToNextSlide(idSlide, nextSlideIndex, isPrev, shouldPushState) {
      if (!idSlide) return
      this.$store.state.idSlide = idSlide
      this.dataSlideNext = {
        id: idSlide,
      }

      const emptySlide = {
        id: null,
        textColour: this.slide.textColour,
      }
      if (this.currentDataNextSlide) {
        emptySlide.timestamp = this.currentDataNextSlide.timestamp
      }
      this.isLoadNextSlide = true

      this.setSlide(emptySlide)

      this.$store.state.isLoadNextSlide[idSlide] = true

      SlideApi.getNextSlide(idSlide)
        .then((res) => {
          if (emptySlide.timestamp && this.currentDataNextSlide && emptySlide.timestamp < this.currentDataNextSlide.timestamp) {
            return false
          }
          this.isLoadNextSlide = false
          this.$store.state.isLoadNextSlide[idSlide] = false
          res.body = Util.formatSlide(res.body)
          this.setSlide(res.body)
          SelfPacedQuiz.playSelfPacedQuizSlide(this.presentation, res.body)
          this.dataSlideNext = null
          return true
        })
        .catch((error) => {
          Sentry.captureException(error)
          this.isLoadNextSlide = false
          this.$store.state.isLoadNextSlide[idSlide] = false
        })

      this.dataSlideNext = null

      const path = `${window.location.pathname}#${nextSlideIndex + 1}`

      if (!isPrev && shouldPushState) {
        window.history.pushState({}, PAGE_TITLE, path)
      }
    },
    selfPacePrevSlide() {
      if (this.currentSlideIndex === 0) return
      const previousSlideIndex = this.currentSlideIndex - 1
      const prevSlide = this.slides[previousSlideIndex]
      this.selfPaceMoveToNextSlide(prevSlide.id, previousSlideIndex, true, true)
      window.location.hash = `#${previousSlideIndex + 1}`
    },
    selfPaceNextSlide() {
      if (!this.slides || !this.slides.length || this.currentSlideIndex === this.slides.length - 1) return
      const thisSlide = this.slides[this.currentSlideIndex]
      const isQuizRelevantTypes = ['pickAnswer', 'leaderboard'].includes(thisSlide.type)
      if (isQuizRelevantTypes && !this.$store.state.audienceName) {
        Util.showToastInfo(this.$t('Join the game to continue.'), 'audience-pace-toast')
        return
      }
      const nextSlideIndex = this.currentSlideIndex + 1
      const nextSlide = this.slides[nextSlideIndex]
      this.selfPaceMoveToNextSlide(nextSlide.id, nextSlideIndex, false, true)
      window.location.hash = `#${nextSlideIndex + 1}`
    },

  },
}
